import type { ITrainingOffer } from "@bbj-types/offer";
import type { ObjectId } from "@bbj-types/utils";

export enum TrainingApplyStatus {
  PROPOSED = "proposed",
  INTERESTED_CANDIDATE = "interestedCandidate",
  REFUSED_CANDIDATE = "refusedCandidate",
  FORWARDED_RECRUITER = "forwardedRecruiter",
  IN_PROGRESS_FILE = "inProgressFile",
  INTEGRATED_CANDIDATE = "integratedCandidate",
  REFUSED_STRUCTURE = "refusedStructure",
}

export interface ITrainingApplyTransition {
  _id: ObjectId;
  createdAt: Date;
  date: Date;
  updatedAt: Date;
  value: TrainingApplyStatus;
  owner: ObjectId;
}

export interface ITrainingApply {
  _id: ObjectId;
  source: string;
  organisation: ObjectId;
  candidate: ObjectId;
  offer: ITrainingOffer;
  status: TrainingApplyStatus;
  statusUpdatedAt: Date;
  transitions: ITrainingApplyTransition[];
  createdAt: Date;
  updatedAt: Date;
}
